"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeVisualLabel = decodeVisualLabel;
exports.readCoordsContainer = readCoordsContainer;
exports.readCadencePosition = readCadencePosition;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const decode_prop_block_1 = require("./decode-prop-block");
function decodeVisualLabel(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for visual label, got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    if (c.length !== 13) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `visual label has ${c.length} children, expected 13`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const intAtom = (n) => n !== undefined && n.type === 'atom' && /^\d+$/.test(n.content.trim()) ? n.content.trim() : null;
    const styleRowIndex = intAtom(c[3]);
    const secondaryStyleRowIndex = intAtom(c[11]);
    const propertyName = c[4].type === 'atom' ? c[4].content.trim() : null;
    const bbox = readCoordsContainer(c[6]);
    const position = readCadencePosition(c[8]);
    const displayFlag = c[10].type === 'atom' ? c[10].content.trim() : null;
    const props = (0, decode_prop_block_1.decodePropBlock)(c[12], `${path}/props`, warnings);
    return {
        kind: 'visual-label',
        styleRowIndex,
        secondaryStyleRowIndex,
        propertyName,
        bbox,
        position,
        displayFlag,
        props,
        raw: node,
    };
}
function readCoordsContainer(node) {
    const ints = readFourAtomInts(node);
    if (ints === null) {
        return null;
    }
    return { x1: ints[0], y1: ints[1], x2: ints[2], y2: ints[3] };
}
function readCadencePosition(node) {
    const ints = readFourAtomInts(node);
    if (ints === null) {
        return null;
    }
    return { x: ints[3], y: ints[1] };
}
function readFourAtomInts(node) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        return null;
    }
    if (node.children.length < 4) {
        return null;
    }
    const ints = [];
    for (let i = 0; i < 4; i++) {
        const child = node.children[i];
        if (child.type !== 'atom') {
            return null;
        }
        const n = parseInt(child.content, 10);
        if (!Number.isFinite(n)) {
            return null;
        }
        ints.push(n);
    }
    return [ints[0], ints[1], ints[2], ints[3]];
}
//# sourceMappingURL=decode-tc31-visual-label.js.map